import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackNavMenuClickedPayload = TrackingPayload & {
    menuName: string;
    parentMenu: string;
};

export const trackNavMenuClickedAnalytics = (payload: TrackNavMenuClickedPayload) => {
    track(TrackingEvents.GlobalNavigation.NavMenuClicked, payload);
};

export const useTrackNavMenuClickedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ menuName, parentMenu }: Pick<TrackNavMenuClickedPayload, 'menuName' | 'parentMenu'>) => {
            trackNavMenuClickedAnalytics({
                menuName,
                pageName: getAmplitudePageNameFromPath(pathname),
                parentMenu,
                url,
            });
        },
        [pathname, url]
    );
};
